import { Stack, StackProps, SxProps, Typography } from '@mui/material';
import StyledAvatar from './Avatar';
import Optional from '../../Optional';
import CircleIcon from '@mui/icons-material/Circle';
import RichText from '../../RichText';
import { AuthorType } from '../cards/type';

type Props = StackProps & {
  author?: AuthorType;
  hideAvatar?: boolean;
  variant?: 'standard' | 'toRight' | 'horizontal';
  sx?: SxProps;
};

const Author = ({ author, hideAvatar, variant, sx }: Props) => {
  if (!author?.fullName) return null;
  const isToRight = variant === 'toRight';
  const isHorizontal =
    variant === 'horizontal' && !!author.fullName && !!author.role;
  return (
    <Stack
      direction={isToRight ? 'row-reverse' : 'row'}
      spacing={1.5}
      sx={{
        alignItems: 'center',
        justifyContent: isToRight ? 'end' : 'start',
        ...(sx as SxProps),
      }}
    >
      <Optional condition={!hideAvatar}>
        <StyledAvatar
          name={author.fullName || ''}
          src={author.image?.url || ''}
          alt={author.image?.altText || 'Author profile image'}
        />
      </Optional>
      <Stack
        sx={{
          height: '100%',
          width: '100%',
          textAlign: isToRight ? 'right' : 'left',
          justifyContent: isHorizontal ? 'start' : 'end',
          alignItems: isToRight ? 'end' : isHorizontal ? 'center' : 'start',
        }}
        direction={isHorizontal ? 'row' : 'column'}
        spacing={isHorizontal ? 1 : 0}
      >
        <Typography variant={'body2'} sx={{ fontWeight: '600' }}>
          {author.fullName}
        </Typography>
        <Optional condition={isHorizontal}>
          <CircleIcon sx={{ fontSize: 8, mx: 1 }} />
        </Optional>
        <RichText withTypography variant={'body2'} color={'textSecondary'}>
          {author.role}
        </RichText>
      </Stack>
    </Stack>
  );
};

export default Author;
